export const products = [
  {
    id: 1,
    name: "iphone 11",
    price: 90,
    img: {
      url: "img1",
      name: "iphone 11 photo",
    },
  },
  {
    id: 2,
    name: "iphone 12",
    price: 120,
    img: {
      url: "img2",
      name: "iphone 12 pro max photo",
    },
  },
];
